import { HttpClient } from "common/services/http-client.service";
import { ApiConfig } from "common/models/api-service/api-config.model";
import { ApiResult } from "common/models/api-service/api-result.model";
import { buildEngApiUrl } from "common/utils/api.util";
import { withApiResponse } from "common/utils/rtk-query.util";

export interface SnowflakeConfigRequest {
  user: string;
  password: string;
  account: string;
  warehouse: string;
  database: string;
  db_schema: string;
}

export interface SnowflakeTablesResponse {
  tables: string[];
}

export interface SnowflakeTableDataResponse {
  table: string;
  columns: string[];
  rows: Record<string, unknown>[];
  count: number;
}

export class SnowflakeService extends HttpClient {
  public static getTables() {
    const config = new ApiConfig(buildEngApiUrl("Snowflake/tables"), "GET");
    return withApiResponse<SnowflakeTablesResponse>(async () => {
      const response = await this.invokeApi<SnowflakeTablesResponse>(config);
      return new ApiResult<SnowflakeTablesResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static getTableData(tableName: string, limit?: number) {
    const queryString = limit ? `limit=${limit}` : "";
    const config = new ApiConfig(
      buildEngApiUrl(`Snowflake/table/${encodeURIComponent(tableName)}`),
      "GET",
      queryString
    );
    return withApiResponse<SnowflakeTableDataResponse>(async () => {
      const response = await this.invokeApi<SnowflakeTableDataResponse>(config);
      return new ApiResult<SnowflakeTableDataResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static saveConfig(payload: SnowflakeConfigRequest) {
    const config = new ApiConfig(
      buildEngApiUrl("Snowflake/config"),
      "POST",
      "",
      payload
    );
    return withApiResponse<unknown>(async () => {
      const response = await this.invokeApi<unknown>(config);
      return new ApiResult<unknown>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static runQuery(query: string) {
    const config = new ApiConfig(
      buildEngApiUrl("Snowflake/query"),
      "POST",
      "",
      { query }
    );
    return withApiResponse<SnowflakeTableDataResponse>(async () => {
      const response = await this.invokeApi<SnowflakeTableDataResponse>(config);
      return new ApiResult<SnowflakeTableDataResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
